import { AxiosRequestConfig } from 'axios'
import { ProfissaoServiceAdapter } from '@/usecases'
import {findProfissao} from '@/api/profissao'


export class ProfissaoService implements ProfissaoServiceAdapter {	
	findProfissao = async (params?: any, config?: AxiosRequestConfig) => await findProfissao(params, config)	
}